import React, { Component } from 'react';
import * as CookieService from '../CookieService';
import * as WaitingRequestorApprovalAction from '../actions/WaitingRequestorApprovalAction';
import WaitingRequestorApprovalStore from '../stores/WaitingRequestorApprovalStore';
import SDIConstants from '../SDIConstants';
import ReactPaginate from 'react-paginate';
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import * as MenuAction from '../actions/MenuAction';
import { withTranslation, Trans } from 'react-i18next'
import * as $ from 'jquery';
import swal from 'sweetalert';
let currentPagePath;
let searchTxt = "";
let isPostBack = true;
let approvalType = "";
let orderDetail;
let NextAprName = "";
let NextAprEmail = "";
let IsDecline = false;
class WaitingRequestorApprovalComponent extends Component {

    constructor(props) {
        super(props);
        this.state = {
            pageNo: 1,
            itemCount: 10,
            searchText: "",
            searchColumn: "ALL",
            sortColumn: "ORDER_NO",
            sortValue: "DESC",
            startDate: "",
            endDate: "",
            isSearch: false,
            reqApprovalsData: [],
            totalCount: 0,
            pageCount: 0,
            filterDisplayName: "All",
            isFilterOpen: false,
            startDateObj: null,
            endDateObj: null,
            isFavorited: false,
            isPageLoadedOnce: false,
            Session_UserID: CookieService.getLocalStorageValues("Session_UserID") ? CookieService.getLocalStorageValues("Session_UserID") : ""
            , RegionDD: [], SubRegionDD: [], Region: "", SubRegion: "", declineReason: "Decline", disabled_button: true, width: 0, height: 0,//***NEW*****wal-336
            Comments: "", NextApprDet: { NextAprName: "", NextAprEmail: "", Order_No: "", WO: "" }, SelectedReason: "",
            inValidComments: false, reasonValue: ""

        };
        this.assignWReqApproval = this.assignWReqApproval.bind(this);
        this.filterClick = this.filterClick.bind(this);
        this.handleSearch = this.handleSearch.bind(this);
        this.handleSearchTxt = this.handleSearchTxt.bind(this);
        this.keyPress = this.keyPress.bind(this);
        this.filtertoggle = this.filtertoggle.bind(this);
        this.sortingClick = this.sortingClick.bind(this);
        this.handleDatePicker = this.handleDatePicker.bind(this);
        this.applyFilterclick = this.applyFilterclick.bind(this);
        this.cancelFilter = this.cancelFilter.bind(this);
        this.loadFavPageResponse = this.loadFavPageResponse.bind(this);
        this.handleFavorite = this.handleFavorite.bind(this);
        this.filtertoggle = this.filtertoggle.bind(this);
        this.exportToExcel = this.exportToExcel.bind(this);
        this.viewReqApproval = this.viewReqApproval.bind(this);
        this.approveDeclineRespone = this.approveDeclineRespone.bind(this);
        this.declineReasonResponse = this.declineReasonResponse.bind(this);
        this.onAccordianClick = this.onAccordianClick.bind(this);
    };

    componentDidMount() {
        CookieService.updateLocalStorageValues("Session_PageName", window.location.pathname);
        currentPagePath = this.props.location.pathname;
        currentPagePath = currentPagePath.indexOf("?") >= 0 ? currentPagePath.split("?")[0] : currentPagePath;
        let getFavPageBO = {
            Session_USERID: CookieService.getLocalStorageValues("Session_UserID"),
            pageURL: currentPagePath.toLowerCase(),
            Session_BUSUNIT: CookieService.getLocalStorageValues("Session_BUSUNIT")

        };
        WaitingRequestorApprovalAction.getCurrentFavPage(getFavPageBO);
        isPostBack = true;
        this.pageLoad(this.state.pageNo,
            this.state.itemCount,
            this.state.searchColumn,
            this.state.searchText,
            this.state.sortColumn,
            this.state.sortValue,
            this.state.startDate,
            this.state.endDate, this.state.Region, this.state.SubRegion);
        WaitingRequestorApprovalStore.on("wrequestorData", this.assignWReqApproval);
        WaitingRequestorApprovalStore.on('favpage', this.loadFavPageResponse);
        WaitingRequestorApprovalStore.on('updateFavPage', this.updateFavPageResponse);
        WaitingRequestorApprovalStore.on('ApproveDeclineResp', this.approveDeclineRespone);
        WaitingRequestorApprovalStore.on('declineReasonResp', this.declineReasonResponse);
    };
    componentWillUnmount() {
        WaitingRequestorApprovalStore.removeListener("wrequestorData", this.assignWReqApproval);
        WaitingRequestorApprovalStore.removeListener('favpage', this.loadFavPageResponse);
        WaitingRequestorApprovalStore.removeListener('updateFavPage', this.updateFavPageResponse);
        WaitingRequestorApprovalStore.removeListener('ApproveDeclineResp', this.approveDeclineRespone);
        WaitingRequestorApprovalStore.removeListener('declineReasonResp', this.declineReasonResponse);
    }
    declineReasonResponse = () => {
        let data = JSON.parse(WaitingRequestorApprovalStore.declineReasonResponse);
        $(`#${SDIConstants.SDILoader}`).addClass('hide');
        let waitingReqData = this.state.reqApprovalsData
        let result = data.Table1[0].lblDBErr1
        if (result == "Successfully Inserted") {
            waitingReqData.splice(this.state.currentIndex, 1)
            swal({
                allowOutsideClick: false,
                closeOnClickOutside: false,
                text: "Decline reason updated successfully"
            });
        }
        else {
            swal({
                allowOutsideClick: false,
                closeOnClickOutside: false,
                text: "Error in updating the decline reason"
            });
        }
        this.setState({
            reqApprovalsData: waitingReqData, totalCount: waitingReqData.length > 0 ? waitingReqData.length : 0,
            pageCount: Math.ceil((waitingReqData.length > 0 ? waitingReqData.length : 0) / this.state.itemCount)
        })
    }
    HandleComments = (e) => {
        this.setState({ Comments: e.target.value, disabled_button: (this.state.reasonValue == "5" && e.target.value =="") || this.state.reasonValue=="" ? true : false })

    }
    onAccordianClick = (event, index) => {
        $(event.currentTarget).children().toggleClass('accordion-arrow-change');
        $(`#contentrow-${index}`).toggleClass('d-none');
        $('tr').removeClass('tr-border');
        $(event.currentTarget).parent('tr').addClass('tr-border');
    };
    approveDeclineRespone = () => {
        //debugger
        $(`#${SDIConstants.SDILoader}`).addClass('hide');
        let multiAppDecRes = JSON.parse(WaitingRequestorApprovalStore.ApproveDeclineResponse)[0];
        let waitingReqData = this.state.reqApprovalsData
        $('#ApprovalComments').modal('hide');
        $('#declineReasonModal').modal('hide');
        if (multiAppDecRes.Status == "Success") {
            if (approvalType == "Approve") {
                if (multiAppDecRes.IsExceeded == "True") {
                    let NextApprDets = {
                        NextAprName: multiAppDecRes.Approver_Name, NextAprEmail: multiAppDecRes.Approver_Mail,
                        Order_No: multiAppDecRes.Order_No, WO: multiAppDecRes.WO
                    }
                    this.setState({ NextApprDet: NextApprDets })
                    $('#limit-exceeded').modal('show');
                }
                else {
                    swal({
                        allowOutsideClick: false,
                        closeOnClickOutside: false,
                        text: "Order approved successfully"
                    });

                }
                MenuAction.refreshMasterData();
                this.pageLoad(1, this.state.itemCount,
                    this.state.searchColumn, searchTxt, this.state.sortColumn,
                    this.state.sortValue, this.state.startDate, this.state.endDate, this.state.Region, this.state.SubRegion
                );
            }
            else {
                if (IsDecline) {
                    let NextApprDets = {
                        NextAprName: multiAppDecRes.Approver_Name, NextAprEmail: multiAppDecRes.Approver_Mail,
                        Order_No: multiAppDecRes.Order_No, WO: multiAppDecRes.WO
                    }
                    this.setState({ NextApprDet: NextApprDets });

                    swal({
                        allowOutsideClick: false,
                        closeOnClickOutside: false,
                        text: "Order declined successfully"
                    }).then(function () {
                        if (multiAppDecRes.IsExceeded == "True") {
                            $('#limit-exceeded').modal('show');

                        }
                    })
                }
                else {
                    swal({
                        allowOutsideClick: false,
                        closeOnClickOutside: false,
                        text: "Decline reason has been updated successfully"
                    });

                }
                MenuAction.refreshMasterData();
                this.pageLoad(1, this.state.itemCount,
                    this.state.searchColumn, searchTxt, this.state.sortColumn,
                    this.state.sortValue, this.state.startDate, this.state.endDate, this.state.Region, this.state.SubRegion
                );
            }

        }
        else {
            if (approvalType == "Approve") {
                swal({
                    allowOutsideClick: false,
                    closeOnClickOutside: false,
                    text: "Error in approving the order"
                });
            } else if (approvalType == "Decline") {
                if (IsDecline) {
                    swal({
                        allowOutsideClick: false,
                        closeOnClickOutside: false,
                        text: "Error in declining the order"
                    });
                }
                else {
                    swal({
                        allowOutsideClick: false,
                        closeOnClickOutside: false,
                        text: "Error in updating the decline reason"
                    });
                }
            }
        }

        this.setState({
            reqApprovalsData: waitingReqData, totalCount: waitingReqData.length > 0 ? waitingReqData.length : 0,
            pageCount: Math.ceil((waitingReqData.length > 0 ? waitingReqData.length : 0) / this.state.itemCount)
        })
    }

    pageLoad = (pageNo, itemCount, searchColumn, searchText, sortColumn, sortValue, startDate, endDate, reg, subreg) => {
        let pageLoadBO = {
            Session_BUSUNIT: CookieService.getLocalStorageValues("Session_BUSUNIT") ? CookieService.getLocalStorageValues("Session_BUSUNIT") : "",
            Session_USERID: this.state.Session_UserID,
            Session_AGENTUSERBU: CookieService.getLocalStorageValues("Session_AGENTUSERBU") ? CookieService.getLocalStorageValues("Session_AGENTUSERBU") : "",
            Session_AGENTUSERID: CookieService.getLocalStorageValues("Session_AGENTUSERID") ? CookieService.getLocalStorageValues("Session_AGENTUSERID") : "",
            Session_USERNAME: CookieService.getLocalStorageValues("Session_USERNAME") ? CookieService.getLocalStorageValues("Session_USERNAME") : "",
            Session_PUNCHIN: CookieService.getLocalStorageValues("Session_PUNCHIN") ? CookieService.getLocalStorageValues("Session_PUNCHIN") : "",
            Session_SDIEMP: CookieService.getLocalStorageValues("Session_SDIEMP") ? CookieService.getLocalStorageValues("Session_SDIEMP") : "",
            Session_USERNAME: CookieService.getLocalStorageValues("Session_USERNAME") ? CookieService.getLocalStorageValues("Session_USERNAME") : "",
            Session_SHOPPAGE: CookieService.getLocalStorageValues("Session_SHOPPAGE") ? CookieService.getLocalStorageValues("Session_SHOPPAGE") : "SHOPPINGCART.ASPX",
            WorkOrderPnchInA: CookieService.getLocalStorageValues("Session_WorkOrderPnchInA") ? CookieService.getLocalStorageValues("Session_WorkOrderPnchInA") : "",
            pageNo: pageNo,
            itemCount: itemCount,
            searchText: searchText,
            searchColumn: searchColumn,
            sortColumn: sortColumn,
            sortValue: sortValue,
            startDate: startDate,
            endDate: endDate,
            Region: reg,
            SubRegion: subreg

        };
        $(`#${SDIConstants.SDILoader}`).removeClass('hide');
        WaitingRequestorApprovalAction.getWaitingReqData(pageLoadBO);
    }
    assignWReqApproval = () => {
        $(`#${SDIConstants.SDILoader}`).addClass('hide');
        let wRequestorData = JSON.parse(WaitingRequestorApprovalStore.wRequestorData);
        console.log("wRequestorData", wRequestorData);
        let Reg = [];
        let sub = [];
        let manager = "";
        if (wRequestorData) {
            /**********NEW*****************wal-336******/
            if (wRequestorData.Division.length > 0) {
                let div = wRequestorData.Division;
                Reg = div.filter((ele, ind) => ind === div.findIndex(elem => elem.REGION === ele.REGION))
                sub = div.filter((ele, ind) => ind === div.findIndex(elem => elem.SUB_REGION === ele.SUB_REGION))
            }

            if (wRequestorData.flagdt.length > 0) {
                manager = wRequestorData.flagdt[0].ATTRIB_MANAGER
            }
            console.log("Reg", Reg);
            console.log("sub", sub);
            console.log("manager", manager);
            /**********END****************/
            if (wRequestorData.flagdt.length > 0) {
                if (wRequestorData.flagdt[0].blockApproval != "Y") {
                    this.setState({
                        reqApprovalsData: wRequestorData.WaitReqApprovalDt,
                        totalCount: wRequestorData.totalCount.length > 0 ? wRequestorData.totalCount[0].TOTAL_COUNT : 0,
                        pageCount: Math.ceil((wRequestorData.totalCount.length > 0 ? wRequestorData.totalCount[0].TOTAL_COUNT : 0) / this.state.itemCount),
                        isPageLoadedOnce: true, RegionDD: Reg, SubRegionDD: sub, Manager: manager
                    });
                }
            }


        }

    };
    exportToExcel = () => {
        let exportBO = {
            Session_BUSUNIT: CookieService.getLocalStorageValues("Session_BUSUNIT") ? CookieService.getLocalStorageValues("Session_BUSUNIT") : "",
            Session_USERID: this.state.Session_UserID,
            Session_AGENTUSERBU: CookieService.getLocalStorageValues("Session_AGENTUSERBU") ? CookieService.getLocalStorageValues("Session_AGENTUSERBU") : "",
            Session_AGENTUSERID: CookieService.getLocalStorageValues("Session_AGENTUSERID") ? CookieService.getLocalStorageValues("Session_AGENTUSERID") : "",
            Session_USERNAME: CookieService.getLocalStorageValues("Session_USERNAME") ? CookieService.getLocalStorageValues("Session_USERNAME") : "",
            Session_PUNCHIN: CookieService.getLocalStorageValues("Session_PUNCHIN") ? CookieService.getLocalStorageValues("Session_PUNCHIN") : "",
            Session_SDIEMP: CookieService.getLocalStorageValues("Session_SDIEMP") ? CookieService.getLocalStorageValues("Session_SDIEMP") : "",
            Session_USERNAME: CookieService.getLocalStorageValues("Session_USERNAME") ? CookieService.getLocalStorageValues("Session_USERNAME") : "",
            Session_SHOPPAGE: CookieService.getLocalStorageValues("Session_SHOPPAGE") ? CookieService.getLocalStorageValues("Session_SHOPPAGE") : "SHOPPINGCART.ASPX",
            WorkOrderPnchInA: CookieService.getLocalStorageValues("Session_WorkOrderPnchInA") ? CookieService.getLocalStorageValues("Session_WorkOrderPnchInA") : "",
            /*[07/20/22,BUG:2324-Filter options should be applied to Export to excel functionality too], Priyanka D */
            searchText: this.state.searchTxt,
            searchColumn: this.state.searchColumn,
            sortColumn: this.state.sortColumn,
            sortValue: this.state.sortValue,
            startDate: this.state.startDate,
            endDate: this.state.endDate
        }

        $(`#${SDIConstants.SDILoader}`).removeClass('hide');
        WaitingRequestorApprovalAction.exportData(exportBO);
    };
    handlePageClick = (data) => {
        let pageNo = data.selected + 1;

        this.setState({ pageNo: pageNo });
        if (this.state.isSearch) {
            searchTxt = $(`#searchTxt`).val().trim();
        }
        isPostBack = false;
        this.setState({ searchTxt: searchTxt })
        this.pageLoad(pageNo, this.state.itemCount,
            this.state.searchColumn, searchTxt, this.state.sortColumn,
            this.state.sortValue, this.state.startDate, this.state.endDate, this.state.Region, this.state.SubRegion);
    };
    filterClick = (event, displayName, columnName) => {
        event.preventDefault();
        this.setState({ filterDisplayName: displayName, searchColumn: columnName });

    };
    handleSearchTxt = () => {
        this.setState({ isSearch: false });
    }
    keyPress(e) {
        if (e.keyCode == 13) {
            this.handleSearch();
        }
    };
    handleSearch = () => {
        let pageNo = 1;
        searchTxt = $(`#searchTxt`).val().trim();
        isPostBack = false;
        this.setState({ pageNo: pageNo, isSearch: true, searchTxt: searchTxt });
        this.pageLoad(pageNo, this.state.itemCount,
            this.state.searchColumn, searchTxt, this.state.sortColumn,
            this.state.sortValue, this.state.startDate, this.state.endDate, this.state.Region, this.state.SubRegion
        );


    };
    filtertoggle = (e) => {
        if (e)
            e.preventDefault();
        this.setState({ isFilterOpen: this.state.isFilterOpen == true ? false : true });
    };
    getDateString = (date) => {
        return (((date.getMonth() > 8) ? (date.getMonth() + 1) : ('0' + (date.getMonth() + 1))) + '/' + ((date.getDate() > 9) ? date.getDate() : ('0' + date.getDate())) + '/' + date.getFullYear())
    };
    handleDatePicker = (date, name) => {
        this.setState({
            [name]: date
        });
        console.log("Date", date);
    };
    applyFilterclick = () => {
        let startDate = this.state.startDateObj ? this.getDateString(this.state.startDateObj) : "";
        let endDate = this.state.endDateObj ? this.getDateString(this.state.endDateObj) : "";
        console.log(startDate, endDate);
        if (this.state.isSearch) {
            searchTxt = $(`#searchTxt`).val().trim();
        }
        isPostBack = false;
        this.pageLoad(1,
            this.state.itemCount,
            this.state.searchColumn,
            searchTxt,
            this.state.sortColumn,
            this.state.sortValue,
            startDate,
            endDate, this.state.Region, this.state.SubRegion);
        this.setState({ pageNo: 1, startDate: startDate, endDate: endDate });
        this.filtertoggle();
    };
    cancelFilter = () => {
        this.setState({
            startDateObj: null,
            endDateObj: null,
            Region: "",
            SubRegion: ""
        })
        let startDate = "";
        let endDate = "";
        let reg = "";
        let subreg = "";
        console.log(startDate, endDate);


        if (this.state.isSearch) {
            searchTxt = $(`#searchTxt`).val().trim();
        }
        isPostBack = false;
        this.pageLoad(1,
            this.state.itemCount,
            this.state.searchColumn,
            searchTxt,
            this.state.sortColumn,
            this.state.sortValue,
            startDate,
            endDate, reg, subreg);
        this.setState({ pageNo: 1, startDate: startDate, endDate: endDate });
        this.filtertoggle();
    };
    sortingClick = (sortColumn, sortValue) => {
        console.log(sortColumn, sortValue);
        if (this.state.isSearch) {
            searchTxt = $(`#searchTxt`).val().trim();
        }
        let pageNo = 1;
        isPostBack = false;
        this.pageLoad(pageNo, this.state.itemCount,
            this.state.searchColumn, searchTxt, this.state.sortColumn,
            this.state.sortValue, this.state.startDate, this.state.endDate, this.state.Region, this.state.SubRegion);
        this.setState({ pageNo: pageNo, sortColumn: sortColumn, sortValue: sortValue });
    };
    viewReqApproval = (event, wreq) => {
        event.preventDefault();
        //debugger;
        let pagePath = `\approvequote`;
        let encodedOrderNo = encodeURIComponent(wreq.ORDER_NO);
        let encodedEMPID = encodeURIComponent(wreq.EMPID);
        let strBU = CookieService.getLocalStorageValues("Session_AGENTUSERID") == "" ? CookieService.getLocalStorageValues("Session_BUSUNIT") : CookieService.getLocalStorageValues("Session_AGENTUSERBU");
        let encodedStrBU = encodeURIComponent(strBU);
        let queryParamsVal = `?fer=${encodedOrderNo}&op=${encodedEMPID}&xyz=${encodedStrBU}&alt=&src=needquote&LINE_FIELD_C6=${wreq.LINE_FIELD_C6}`;
        this.props.history.push({
            pathname: pagePath,
            search: queryParamsVal
        });
    }
    bindWaitingReqGrid = () => {
        //debugger
        const { t } = this.props;
        let locGridArr = this.state.reqApprovalsData.filter((v, i, a) => a.findIndex(t => (t.ORDER_NO.trim().toUpperCase() === v.ORDER_NO.trim().toUpperCase())) === i);
        return locGridArr.map((wreq, windex) => {
            return (<React.Fragment key={`key${windex}`}>
                <tr key={wreq.ORDER_NO + "-" + windex}>
                    <td className="Waitreq-accordion-toggle mobile-block" onClick={(e) => this.onAccordianClick(e, windex)} >
                        <span id={`accordian-class-${windex}`} className="accordion-arrow header-arrow" />
                    </td>
                    <td><a href="#" className="order-id" onClick={(e) => this.viewReqApproval(e, wreq)}>{wreq.ORDER_NO}</a></td>
                    <td className="d-none d-sm-none d-md-table-cell">{wreq.EMPNAME}</td>
                    <td className="d-none d-sm-none d-md-table-cell">{wreq.ADD_DT}</td>
                    <td className="d-none d-sm-none d-md-table-cell">{wreq.CURRENT_APPR_NAME}</td>
                    <td className="d-none d-sm-none d-md-table-cell">{wreq.ISA_USER1}</td>
                    <td><span className="warning-icon mr-2" />{wreq.CURRENT_APPR_ID == this.state.Session_UserID ? `Waiting For your Approval` : `This order/quote is still waiting approval from  ${wreq.CURRENT_APPR_NAME}  .`}</td>
                    <td className="d-none d-sm-none d-md-table-cell">{wreq.SHIPTO}</td>
                    {this.state.Manager == "MANAGER" || this.state.Manager == "REGMANAGER" ? <>
                        <td className="d-none d-sm-none d-md-table-cell" >{wreq.REG}</td>
                        <td className="d-none d-sm-none d-md-table-cell" >{wreq.SUBREG}</td></> : null}
                    <td className="btn-column text-center">
                        <button className="btn  grid-btn-approve waitReqApproveBtn-Margin" onClick={() => this.approveClick(windex, wreq)}><Trans>Approve</Trans></button>
                        <button className="btn  grid-btn-decline waitReqDeclineBtn" onClick={() => this.declineClick(windex, wreq)}><Trans>Decline</Trans></button>

                    </td>
                </tr>
                <tr className="p d-none content-row" id={`contentrow-${windex}`}>
                    <td colSpan={12} className="hiddenRow">
                        <div className="col-md-12 mx-0 mobile-fieldscontainer d-lg-none d-block item-box py-3" id="Header">
                            <div className="row pl-5">
                                <div className="col-12 mobile-fields p-0">
                                    <label className="catalog-label">Order Entered by <span>:</span></label>
                                    <label className="item-details-value">{wreq.EMPNAME}</label>
                                </div>
                                <div className="col-12 mobile-fields p-0">
                                    <label className="catalog-label">Created Date <span>:</span></label>
                                    <label className="item-details-value">{wreq.ADD_DT}</label>
                                </div>
                                <div className="col-12 mobile-fields p-0">
                                    <label className="catalog-label">Pending Approver <span>:</span></label>
                                    <label className="item-details-value">{wreq.CURRENT_APPR_NAME}</label>
                                </div>

                                <div className="col-12 mobile-fields p-0">
                                    <label className="catalog-label">Ship To <span>:</span></label>
                                    <label className="item-details-value">{wreq.SHIPTO}</label>
                                </div>
                                {this.state.Manager == "MANAGER" || this.state.Manager == "REGMANAGER" ? <>
                                    <div className="col-12 mobile-fields p-0">
                                        <label className="catalog-label">Region<span> </span><span>:</span></label>
                                        <label className="item-details-value">{wreq.REG}</label>
                                    </div>
                                    <div className="col-12 mobile-fields p-0">
                                        <label className="catalog-label">Subregion<span> </span><span>:</span></label>
                                        <label className="item-details-value">{wreq.SUBREG}</label>
                                    </div></> : null}

                            </div>
                        </div>
                    </td>
                </tr>
            </React.Fragment>);

        });

    };

    updateFavPageResponse = () => {
        if (WaitingRequestorApprovalStore.updateFavPageResponse.updateType == 1) {
            let response = JSON.parse(WaitingRequestorApprovalStore.updateFavPageResponse.responseStr)[0];
            if (response.is_Success == "True") {
                $(`#${SDIConstants.SDILoader}`).addClass('hide');
                this.setState({ isFavorited: true, Page_ID: response.Page_ID });
                MenuAction.toastMessage(1);
            }
        } else {
            let response = JSON.parse(WaitingRequestorApprovalStore.updateFavPageResponse.responseStr)[0];
            if (response.success == "true") {
                $(`#${SDIConstants.SDILoader}`).addClass('hide');
                this.setState({ isFavorited: false });
                MenuAction.toastMessage(2);
            }
        }
    };
    /**
    * Handle change method for favorite page checkbox
    * @param event
    */
    handleFavorite = (event) => {
        this.setState({ isFavorited: event.target.checked });
        $(`#${SDIConstants.SDILoader}`).removeClass('hide');
        if (event.target.checked == true) {
            let insertFavPageBO = {
                Session_USERID: CookieService.getLocalStorageValues("Session_UserID"),
                pageURL: currentPagePath.toLowerCase(),
                pageTitle: "Waiting Requestor Approval",
                Session_BUSUNIT: CookieService.getLocalStorageValues("Session_BUSUNIT")

            }
            WaitingRequestorApprovalAction.insertFavPage(insertFavPageBO)
        } else {
            let deleteFavPageBO = {
                Page_ID: this.state.Page_ID
            }
            WaitingRequestorApprovalAction.deleteFavPage(deleteFavPageBO)
        }
    };
    /**
    * Listener method for loading favorite page icon
    */
    loadFavPageResponse = () => {
        let favPageResponse = JSON.parse(WaitingRequestorApprovalStore.currentFavPageResponse);
        if (favPageResponse.length > 0) {
            favPageResponse = favPageResponse[0];
            this.setState({ isFavorited: true, Page_ID: favPageResponse.PAGE_ID });
        };
    };

    /******NEW******wal-336************/

    RegionDDmap = () => {
        return this.state.RegionDD.map((value, ID) => {
            if (value.REGION != "" && value.REGION != null && value.REGION != undefined) {
                return (
                    <option key={value.REGION} value={value.REGION}>{value.REGION}</option>
                )
            }
        });
    }
    SubRegionDDmap = () => {
        return this.state.SubRegionDD.map((value, ID) => {
            if (value.SUB_REGION != "" && value.SUB_REGION != null && value.SUB_REGION != undefined) {
                return (
                    <option key={value.SUB_REGION} value={value.SUB_REGION}>{value.SUB_REGION}</option>
                )
            }

        });
    }

    handlechange = (event) => {
        this.setState({ [event.target.name]: event.target.value });
        console.log("event.target.name", event.target.name);
        console.log("event.target.value", event.target.value);
    }

    approveClick = (windex, wreq) => {
        //debugger
        orderDetail = wreq;
        $('#approveAlert').modal('show');
        this.setState({ currentIndex: windex })
    };
    aprvalCancel = () => {
        $('#approveAlert').modal('hide');
    }
    aprvalContinue = (popUp) => {
        if (popUp) {
            $('#ApprovalComments').modal('show');
            this.setState({Comments: "", inValidComments: false })
        }
        else {
            this.approveDeclineOrder(true, "Approve")
        }
    }
    approveDeclineOrder = (isApprove, approveType) => {
        //debugger
        $('#approveAlert').modal('hide');
        $(`#${SDIConstants.SDILoader}`).removeClass('hide');
        approvalType = approveType;
        let QS_fer = orderDetail.ORDER_NO;
        let QS_op = orderDetail.EMPID;
        let QS_xyz = CookieService.getLocalStorageValues("Session_AGENTUSERID") == "" ? CookieService.getLocalStorageValues("Session_BUSUNIT") : CookieService.getLocalStorageValues("Session_AGENTUSERBU");
        let LINE_FIELD_C6 = orderDetail.LINE_FIELD_C6;
        let reason = $("#declreasondrop option:selected").text();
        let re = this.state.SelectedReason;
        let comments = this.state.Comments;
        let waitingReqBO = {
            QS_fer: QS_fer ? QS_fer : "",
            QS_op: QS_op ? QS_op : "",
            QS_xyz: QS_xyz ? QS_xyz : "",
            bFromEmailLink: false,
            Session_BUSUNIT: CookieService.getLocalStorageValues("Session_BUSUNIT") ? CookieService.getLocalStorageValues("Session_BUSUNIT") : "",
            Session_USERID: CookieService.getLocalStorageValues("Session_UserID") ? CookieService.getLocalStorageValues("Session_UserID") : "",
            Session_USERNAME: CookieService.getLocalStorageValues("Session_USERNAME") ? CookieService.getLocalStorageValues("Session_USERNAME") : "",
            Session_PUNCHIN: CookieService.getLocalStorageValues("Session_PUNCHIN") ? CookieService.getLocalStorageValues("Session_PUNCHIN") : "",
            Session_WorkOrderPnchInA: CookieService.getLocalStorageValues("Session_WorkOrderPnchInA") ? CookieService.getLocalStorageValues("Session_WorkOrderPnchInA") : "",
            Session_ValidateWorkOrder: CookieService.getLocalStorageValues("Session_ValidateWorkOrder") ? CookieService.getLocalStorageValues("Session_ValidateWorkOrder") : "",
            Session_CARTWOREQ: CookieService.getLocalStorageValues("Session_CARTWOREQ") ? CookieService.getLocalStorageValues("Session_CARTWOREQ") : "",
            LINE_FIELD_C6: LINE_FIELD_C6 ? LINE_FIELD_C6 : "",
            Session_itemMode: CookieService.getLocalStorageValues("Session_itemMode") ? CookieService.getLocalStorageValues("Session_itemMode") : "",
            Session_IOLServer: CookieService.getLocalStorageValues("Session_IOLServer") ? CookieService.getLocalStorageValues("Session_IOLServer") : "",
            Session_cplusServer: CookieService.getLocalStorageValues("Session_cplusServer") ? CookieService.getLocalStorageValues("Session_cplusServer") : "",
            Session_SITEPREFIX: CookieService.getLocalStorageValues("Session_SITEPREFIX") ? CookieService.getLocalStorageValues("Session_SITEPREFIX") : "",
            Session_ISABudgetaryLimit: CookieService.getLocalStorageValues("Session_ISABudgetaryLimit") ? CookieService.getLocalStorageValues("Session_ISABudgetaryLimit") : "",
            isApprove: isApprove,
            User_Type: CookieService.getLocalStorageValues("Session_USERTYPE") ? CookieService.getLocalStorageValues("Session_USERTYPE") : "",
            txtWO: orderDetail.WRK_ORDR_NUM,
            DeclineReason: re,
            Comments: comments,
            OrderNotes: {
                UserID: CookieService.getLocalStorageValues("Session_UserID"),
                BU: CookieService.getLocalStorageValues("Session_BUSUNIT"),
                ISA_LINE_STATUS: isApprove ? "QSA" : "QSR",
                Line_NO: [0],
                Ordernotes: comments,
                OrderNO: QS_fer
            }
        };
        WaitingRequestorApprovalAction.waitingReqApproveDecline(waitingReqBO)
    }
    declineClick = (windex, wreq) => {
        //debugger
        orderDetail = wreq;
        $('#declineReasonModal').modal('show');
        this.setState({ currentIndex: windex, Comments: "", inValidComments: false, reasonValue: "" })
    };
    cancelclick = (event) => {
        document.getElementById("declreasondrop").value = "0"
        document.getElementById("decreasoncmt").value = ""
        this.setState({ declineReason: "Decline", Comments: "", inValidComments: false, reasonValue: "", disabled_button: true })
    };
    handleReasonchange = (event) => {
        //debugger
        if (event.target.value == '' || event.target.value == "0" || (event.target.value == "5" && this.state.Comments == "")) {
            this.state.disabled_button = true;
        }
        else {
            this.state.disabled_button = false;

        }
        let index = event.nativeEvent.target.selectedIndex;
        let text = event.nativeEvent.target[index].text;
        if (event.target.value == "5" || event.target.value == "0") {
            IsDecline = true
        }
        else {
            IsDecline = false
        }
        this.setState({ declineReason: IsDecline ? "Decline" : "Submit", SelectedReason: text, reasonValue: event.target.value, inValidComments: false })
        let samval = $("#declreasondrop option:selected").text();
    };
    ExceededOkClick = () => {

        //this.pageLoad(this.state.pageNo,
        //this.state.itemCount,
        //this.state.searchColumn,
        //this.state.searchText,
        //this.state.sortColumn,
        //this.state.sortValue,
        //this.state.startDate,
        //this.state.endDate, this.state.Region, this.state.SubRegion);


    }
    HandleDecSubClick = () => {
        if (this.state.reasonValue == 5 && this.state.Comments.length < 5) {
            this.setState({ inValidComments: true })
        }
        else {
            $('#declineReasonModal').modal('hide');
            this.cancelclick();
            this.approveDeclineOrder(false, "Decline");
        }
    };

    /*****END*******/



    render() {
        const { t } = this.props;
        return (
            <div>
                <div className="container-fluid content-section">
                    <div className="row">
                        {/* Waiting Request Approval starts */}
                        <div className="container-fluid content-margin">
                            <div className="row">
                                <div className="col-md-12 page-heading mb-3 title-margin mt-3">
                                    <h5 className="page-title">{t("Waiting")} {t("r_a")}</h5>
                                    <div className="fav-item-maintenance-icon mt-1">
                                        <input type="checkbox" id="checkbox-1" className="checknow" name="isFavorited" checked={this.state.isFavorited} onChange={this.handleFavorite} />
                                        <label htmlFor="checkbox-1">
                                            <svg className="heart-svg" viewBox="467 392 58 57" xmlns="http://www.w3.org/2000/svg">
                                                <g className="Group" fill="none" fillRule="evenodd" transform="translate(467 392)">
                                                    <path d="M29.144 20.773c-.063-.13-4.227-8.67-11.44-2.59C7.63 28.795 28.94 43.256 29.143 43.394c.204-.138 21.513-14.6 11.44-25.213-7.214-6.08-11.377 2.46-11.44 2.59z" className="heart" fill="#fff" />
                                                    <circle className="main-circ" fill="#E2264D" opacity={0} cx="29.5" cy="29.5" r="1.5" />
                                                    <g className="grp7" opacity={0} transform="translate(7 6)">
                                                        <circle className="oval1" fill="#9CD8C3" cx={2} cy={6} r={2} />
                                                        <circle className="oval2" fill="#8CE8C3" cx={5} cy={2} r={2} />
                                                    </g>
                                                    <g className="grp6" opacity={0} transform="translate(0 28)">
                                                        <circle className="oval1" fill="#CC8EF5" cx={2} cy={7} r={2} />
                                                        <circle className="oval2" fill="#91D2FA" cx={3} cy={2} r={2} />
                                                    </g>
                                                    <g className="grp3" opacity={0} transform="translate(52 28)">
                                                        <circle className="oval2" fill="#9CD8C3" cx={2} cy={7} r={2} />
                                                        <circle className="oval1" fill="#8CE8C3" cx={4} cy={2} r={2} />
                                                    </g>
                                                    <g className="grp2" opacity={0} transform="translate(44 6)">
                                                        <circle className="oval2" fill="#CC8EF5" cx={5} cy={6} r={2} />
                                                        <circle className="oval1" fill="#CC8EF5" cx={2} cy={2} r={2} />
                                                    </g>
                                                    <g className="grp5" opacity={0} transform="translate(14 50)">
                                                        <circle className="oval1" fill="#91D2FA" cx={6} cy={5} r={2} />
                                                        <circle className="oval2" fill="#91D2FA" cx={2} cy={2} r={2} />
                                                    </g>
                                                    <g className="grp4" opacity={0} transform="translate(35 50)">
                                                        <circle className="oval1" fill="#F48EA7" cx={6} cy={5} r={2} />
                                                        <circle className="oval2" fill="#F48EA7" cx={2} cy={2} r={2} />
                                                    </g>
                                                    <g className="grp1" opacity={0} transform="translate(24)">
                                                        <circle className="oval1" fill="#9FC7FA" cx="2.5" cy={3} r={2} />
                                                        <circle className="oval2" fill="#9FC7FA" cx="7.5" cy={2} r={2} />
                                                    </g>
                                                </g>
                                            </svg>
                                        </label>
                                    </div>
                                </div>
                                {this.state.isPageLoadedOnce && this.state.totalCount == 0 && isPostBack == true ? null : <div className="col-md-12">
                                    <div className="float-right">
                                        {/********************New**ADDED(CONDTION)(1/25/2021)**********************/}
                                        {this.state.totalCount == 0 ? null :
                                            <button className="btn btn-primary custom-btn-primary primary-btn float-left mr-3 mb-2" onClick={this.exportToExcel}>{t("Export to Excel")}</button>}
                                        {/************************end*************************/}
                                        <div className="input-group dropdown-search float-left mb-2 req-search-width">
                                            <div className="input-group-prepend">
                                                <button className="btn btn-outline-secondary dropdown-toggle" type="button" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">{this.state.filterDisplayName}</button>
                                                <div className="dropdown-menu" style={{}}>
                                                    <a className="dropdown-item" href="#" onClick={(e) => this.filterClick(e, "All", "ALL")}>{t("All")}</a>
                                                    <a className="dropdown-item" href="#" onClick={(e) => this.filterClick(e, "Order Number", "ORDER_NO")}>{t("order_key")} #</a>
                                                    <a className="dropdown-item" href="#" onClick={(e) => this.filterClick(e, "Order Entered by", "EMPNAME")}>{t("orderenteredby_key")}</a>
                                                    <a className="dropdown-item" href="#" onClick={(e) => this.filterClick(e, "Pending Approver", "CURRENT_APPR_NAME")} >{t("Pending Approver")}</a>
                                                    <a className="dropdown-item" href="#" onClick={(e) => this.filterClick(e, "Ship To", "SHIPTO")} >{t("Ship To")}</a>
                                                    <a className="dropdown-item" href="#" onClick={(e) => this.filterClick(e, "Region", "REG")} >{t("Region")}</a>
                                                    <a className="dropdown-item" href="#" onClick={(e) => this.filterClick(e, "Sub Region", "SUBREG")} >{t("Sub Region")}</a>
                                                </div>
                                            </div>
                                            <input type="text" className="form-control" id="searchTxt" placeholder="Search" aria-label="Text input with dropdown button" onKeyDown={this.keyPress} onChange={this.handleSearchTxt} />
                                            <span className="dropdown-search-icon" onClick={this.handleSearch} />
                                        </div>
                                        <div className="dropdown float-right">
                                            <a href="#" className="float-right filter-icon mt-1 mx-2" title="Advance Filter" onClick={(e) => this.filtertoggle(e)}>
                                                <img src="images/filter-icon.png" alt="Filter Icon" />
                                            </a>
                                            <div className={`dropdown-menu order-maintenance-filter m-0 ${this.state.isFilterOpen ? 'd-block' : ''}`} id="advanced-filter">
                                                <div className="container-fluid">
                                                    <div className="row">
                                                        <div className="col-md-12 p-0 pb-2 border-bottom mb-3">
                                                            <span className="filter-title pl-3">{t("Filter")}</span>
                                                            <button type="button" className="filter-close close pr-2 filter-btn" onClick={(e) => this.filtertoggle(e)}><span className="filter-close-icon" /></button>
                                                        </div>
                                                        <div className="col-md-12">
                                                            <label className="catalog-label mb-0">{t("Created")} {t("Date")}</label> </div>
                                                        <div className="col-md-6 mb-4">
                                                            <label className="catalog-label mb-0 w-100">From</label>
                                                            <DatePicker className="form-control waitReq-datepicker"
                                                                id="startDateObj"
                                                                popperPlacement="bottom-end"
                                                                placeholderText="MM/DD/YYYY"
                                                                dateFormat="MM/dd/yyyy"
                                                                showMonthDropdown
                                                                showYearDropdown
                                                                selected={this.state.startDateObj}
                                                                maxDate={this.state.endDateObj}
                                                                onChange={(e) => this.handleDatePicker(e, "startDateObj")}
                                                            />
                                                            <span className="calendar-icon filter-calendar-icon-approval" style={{ "top": "37px" }} onClick={() => $(`#startDateObj`).focus()} />
                                                        </div>
                                                        <div className="col-md-6 mb-4">
                                                            <label className="catalog-label mb-0 w-100">To</label>
                                                            <DatePicker className="form-control waitReq-datepicker"
                                                                popperPlacement="bottom-end"
                                                                id="endDateObj"
                                                                placeholderText="MM/DD/YYYY"
                                                                dateFormat="MM/dd/yyyy"
                                                                showMonthDropdown
                                                                showYearDropdown
                                                                selected={this.state.endDateObj}
                                                                minDate={this.state.startDateObj}
                                                                onChange={(e) => this.handleDatePicker(e, "endDateObj")}

                                                            />
                                                            <span className="calendar-icon filter-calendar-icon-approval" style={{ "top": "37px" }} onClick={() => $(`#endDateObj`).focus()} />
                                                        </div>
                                                        {/******NEW*wal-336******/}
                                                        {this.state.Manager == "MANAGER" || this.state.Manager == "REGMANAGER" ? <>
                                                            {this.state.RegionDD.length > 0 ?
                                                                <div className="col-md-6 mb-4">
                                                                    <label className="catalog-label mb-0 w-100">{t("Region")}</label>
                                                                    <div >
                                                                        <select className="form-control" name="Region" value={this.state.Region} onChange={this.handlechange}>

                                                                            <option value="">{t("select")} </option>
                                                                            {this.RegionDDmap()}
                                                                        </select>

                                                                    </div>
                                                                </div> : null}
                                                            {this.state.SubRegionDD.length > 0 ?
                                                                <div className="col-md-6 mb-4">
                                                                    <label className="catalog-label mb-0 w-100">{t("Sub Region")}</label>
                                                                    <div >
                                                                        <select className="form-control" name="SubRegion" value={this.state.SubRegion} onChange={this.handlechange}>

                                                                            <option value="">{t("select")}</option>
                                                                            {this.SubRegionDDmap()}
                                                                        </select>

                                                                    </div>
                                                                </div> : null}
                                                        </> : null}
                                                        {/*******END********/}
                                                        <div className="col-md-12 mb-2">
                                                            <div className="float-right">
                                                                <button className="btn btn-primary filter-clear-btn px-4 mr-2 filter-btn" onClick={this.cancelFilter} >{t("clear")}</button>
                                                                <button className="btn btn-primary custom-btn-primary primary-btn filter-btn wallet-btn px-4" onClick={this.applyFilterclick}>{t("Apply")}</button>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>}
                                <div className="col-lg-12">
                                    <div className="table-responsive">
                                        {this.state.isPageLoadedOnce && this.state.totalCount == 0 && isPostBack == true ? (<section className="site-undercontruction container text-center center-panel pt-4">
                                            <div className="img-section">
                                                <img src="images/nosearch.jpg" alt="imagefile" />
                                            </div>
                                            <p className="search-result-content pt-4">{t("No Records Found")}
                                            </p>
                                        </section>) : (<table className="table ZEUS_Grid FOM-grid">
                                            <thead className="thBG">
                                                <tr>
                                                    <th className="mobile-block" />
                                                    <th className="position-sort-icon">{t("order_key")} {t("Number")}<span><img className="sort-up ml-1" style={{ top: '12px' }} src="Images/sort2.svg" onClick={(e) => this.sortingClick(`ORDER_NO`, `ASC`)} /></span><span ><img className="sort-down ml-1" style={{ bottom: '13px' }} src="Images/sort1.svg" onClick={(e) => this.sortingClick(`ORDER_NO`, `DESC`)} /></span></th>
                                                    <th className="d-none d-sm-none d-md-table-cell position-sort-icon">{t("orderenteredby_key")}<span><img className="sort-up ml-1" style={{ top: '12px' }} src="Images/sort2.svg" onClick={(e) => this.sortingClick(`EMPNAME`, `ASC`)} /></span><span ><img className="sort-down ml-1" style={{ bottom: '13px' }} src="Images/sort1.svg" onClick={(e) => this.sortingClick(`EMPNAME`, `DESC`)} /></span></th>
                                                    <th className="d-none d-sm-none d-md-table-cell position-sort-icon">{t("Created")} {t("Date")}<span><img className="sort-up ml-1" style={{ top: '12px' }} src="Images/sort2.svg" onClick={(e) => this.sortingClick(`ADD_DT`, `ASC`)} /></span><span ><img className="sort-down ml-1" style={{ bottom: '13px' }} src="Images/sort1.svg" onClick={(e) => this.sortingClick(`ADD_DT`, `DESC`)} /></span></th>
                                                    <th className="d-none d-sm-none d-md-table-cell position-sort-icon">{t("Pending Approver")}<span><img className="sort-up ml-1" style={{ top: '12px' }} src="Images/sort2.svg" onClick={(e) => this.sortingClick(`CURRENT_APPR_NAME`, `ASC`)} /></span><span ><img className="sort-down ml-1" style={{ bottom: '13px' }} src="Images/sort1.svg" onClick={(e) => this.sortingClick(`CURRENT_APPR_NAME`, `DESC`)} /></span></th>
                                                    <th className="d-none d-sm-none d-md-table-cell position-sort-icon">{t("Next Approver")}<span><img className="sort-up ml-1" style={{ top: '12px' }} src="Images/sort2.svg" onClick={(e) => this.sortingClick(`ISA_USER1`, `ASC`)} /></span><span ><img className="sort-down ml-1" style={{ bottom: '13px' }} src="Images/sort1.svg" onClick={(e) => this.sortingClick(`ISA_USER1`, `DESC`)} /></span></th>
                                                    <th className="position-sort-icon">{t("Status")}</th>
                                                    <th className="d-none d-sm-none d-md-table-cell position-sort-icon">{t("Ship To")}<span><img className="sort-up ml-1" style={{ top: '12px' }} src="Images/sort2.svg" onClick={(e) => this.sortingClick(`SHIPTO`, `ASC`)} /></span><span><img className="sort-down ml-1" style={{ bottom: '13px' }} src="Images/sort1.svg" onClick={(e) => this.sortingClick(`SHIPTO`, `DESC`)} /></span></th>
                                                    {this.state.Manager == "MANAGER" || this.state.Manager == "REGMANAGER" ?
                                                        <>
                                                            <th className="d-none d-sm-none d-md-table-cell position-sort-icon">{t("Region")}</th>
                                                            <th className="d-none d-sm-none d-md-table-cell position-sort-icon">{t("Sub Region")}</th></> : null}
                                                    <th className="d-sm-none d-md-table-cell position-sort-icon text-center"><Trans>Action</Trans></th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {this.state.isPageLoadedOnce && this.state.totalCount > 0 ? this.bindWaitingReqGrid() :
                                                    (<tr className="border-0">
                                                        <td colSpan="11" className="search-padding-none">
                                                            <section className="site-undercontruction container text-center center-panel pt-4">
                                                                <div className="img-section">
                                                                    <img src="images/nosearch.jpg" alt="imagefile" />
                                                                </div>
                                                                <p className="search-result-content pt-4">{t("No Records Found")}
                                                                </p>
                                                            </section>
                                                        </td>
                                                    </tr>)}
                                            </tbody>
                                        </table>)}
                                    </div>
                                </div>
                                {this.state.totalCount > 0 ? <div className="col-md-12">
                                    <span className="total-records mt-2 d-inline-block">
                                        {t("Number of Records")}:<span className="ml-2">{this.state.totalCount}</span>
                                    </span>
                                    {this.state.totalCount > this.state.itemCount ? <ReactPaginate
                                        previousLabel={<span className="right-pagination-arrow" />}
                                        nextLabel={<span className="left-pagination-arrow" />}
                                        previousClassName={'page-item'}
                                        nextClassName={'page-item'}
                                        previousLinkClassName={'page-link'}
                                        nextLinkClassName={'page-link'}
                                        disabledClassName={'disabled'}
                                        breakLabel={'...'}
                                        breakClassName={'page-item'}
                                        breakLinkClassName={'page-link'}
                                        pageCount={this.state.pageCount}
                                        marginPagesDisplayed={1}
                                        pageRangeDisplayed={2}
                                        onPageChange={this.handlePageClick}
                                        containerClassName={'custom-pagination pagination float-right'}
                                        pageClassName={'page-item'}
                                        pageLinkClassName={'page-link'}
                                        activeClassName={'active'}
                                        hrefBuilder={() => '#'}
                                        forcePage={this.state.pageNo - 1}
                                    /> : null}
                                </div> : null}
                            </div>
                        </div>
                    </div>
                </div>


                {/*approveAlert Modal starts here*/}
                <div className="modal" id="approveAlert">
                    <div className="modal-dialog modal-md custom-popup modal-dialog-centered">
                        <div className="modal-content">

                            {/* Modal body */}
                            <div className="modal-body">
                                <div className="row text-center">
                                    <div className="col-12 mb-4">
                                        <label className="confirm-content d-block">Click continue to approve all the line items of this order.</label>
                                    </div>
                                    <div className="col-md-12 text-center mb-2">
                                        <button className="btn btn-primary custom-btn-primary primary-btn mr-3 pl-3 pr-3" data-dismiss="modal" onClick={() => this.aprvalContinue(true)}>Continue</button>
                                        <button className="btn btn-secondary custom-btn-secondary secondary-btn px-4" data-dismiss="modal" onClick={() => this.aprvalCancel()}>Cancel</button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                {/*approveAlert Modal ends here*/}
                {/*declineReason Modal starts here*/}
                <div className="modal" id="declineReasonModal" aria-modal="true" data-backdrop="static">
                    <div className="modal-dialog modal-md custom-popup modal-dialog-centered">
                        <div className="modal-content">
                            {/*Modal Header*/}

                            <div className="modal-header">
                                <h4 className="modal-title mt-1"><Trans>Reason for Decline</Trans></h4>
                                <button type="button" className="btn close-btn" onClick={() => this.cancelclick()} data-dismiss="modal">
                                    X
                                          </button>
                            </div>
                            {/*Modal body*/}

                            <div className="modal-body">
                                <div className="row">
                                    <div className="col-md-12 float-left">
                                        <div className="col-md-12 col-lg-12 mb-3 float-left p-0">



                                            <label className="col-lg-12 col-md-12 float-left p-0 catalog-label form-label"><Trans>Reason</Trans><span className="color-manditory" id="CmntsMandatory">*</span></label>
                                            <div className="col-lg-12 col-md-12 float-left p-0 col-12">
                                                <select className="form-control" id="declreasondrop" value={this.state.reasonValue} onChange={this.handleReasonchange}>

                                                    <option value={''}> {t("Select")}</option>
                                                    <option value={1} > {t("Too Expensive (Need Cheaper Quote)")}</option>
                                                    <option value={2} > {t("Wrong Quantities")}</option>
                                                    <option value={3} > {t("Wrong Item(s)")}</option>
                                                    <option value={4} > {t("Wrong Ship To Store")}</option>
                                                    <option value={5} > {t("No Longer Needed")}</option>
                                                </select>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-md-12 col-lg-12 moredetail-content">
                                        {this.state.reasonValue == "5" ? <span className="color-manditory" id="CmntsMandatory">*</span> : null}
                                        <label className="catalog-label d-block"><Trans>Comments</Trans></label>
                                        <textarea className={`form-control custom-textarea ${this.state.inValidComments && this.state.Comments.length < 5 ? 'border-color-red' : ''}`} maxLength="254" id="decreasoncmt" placeholder="" onChange={(e) => this.HandleComments(e)} value={this.state.Comments}></textarea>
                                        <div>
                                            {this.state.inValidComments && this.state.Comments.length < 5 ? <label style={{ 'font-size': '15px', 'color': 'red' }} id="NotesLAbel">Please enter minimum 5 characters</label> : null}
                                            <span className="commentscount">{this.state.Comments.length}/254</span>
                                        </div>
                                    </div>
                                </div>
                                <div className="col-md-12 mt-2 text-right p-0">
                                    <button className="btn btn-secondary custom-btn-secondary secondary-btn mr-3 px-4 mt-3" onClick={() => this.cancelclick()} data-dismiss="modal"><Trans>Cancel</Trans></button>
                                    <button className="btn btn-primary custom-btn-primary primary-btn px-4 mt-3" id="subdecbtn" disabled={this.state.disabled_button} onClick={() => this.HandleDecSubClick()}><Trans>{this.state.declineReason}</Trans></button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                {/*declineReason Modal ends here*/}
                {/*WW-1044 - Limit Exceeded Modal Starts here*/}
                <div className="modal fade limit-exceeded-popup p-0 show " id="limit-exceeded" tabIndex={-1} role="dialog" aria-modal="true" style={{ paddingLeft: '17px' }}>
                    <div className="modal-dialog modal-dialog-centered custom-bin-location-width" role="document">
                        <div className="modal-content border-0">
                            <div className="modal-header sp-delv-header align-items-center border-0">
                                <h5 className="modal-title" id="exampleModalLongTitle">Order limit exceeded</h5>
                                <button type="button" className="btn-close" data-dismiss="modal" aria-label="Close"><img src="images/close-icon.svg" alt="close" onClick={(e) => this.ExceededOkClick()} /></button>
                            </div>

                            <div className="modal-body py-4">
                                <div className="row">
                                    <div className="col-md-12 mb-3">
                                        <span className="font-14 font-regular custom-label-color mb-1">Order limit has exceeded and sent to next level approver</span>
                                    </div>

                                    <div className="col-md-12 mt-1">

                                        <div className="table-responsive popup-grid-scroll-style">
                                            <table className="table split-delv-table mb-0">
                                                <thead className="sticky-top">
                                                    <tr>
                                                        <th>Order #</th>
                                                        <th>Work order #</th>
                                                        <th>Approver name</th>
                                                        <th>Email ID</th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    <tr className="border-bottom">
                                                        <td>{this.state.NextApprDet.Order_No}</td>
                                                        <td>{this.state.NextApprDet.WO}</td>
                                                        <td>{this.state.NextApprDet.NextAprName}</td>
                                                        <td>{this.state.NextApprDet.NextAprEmail}</td>
                                                    </tr>
                                                </tbody>
                                            </table>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="modal-footer border-0 d-flex justify-content-center mb-2">
                                <button className="btn btn-custom-primary font-14 font-medium px-4" data-dismiss="modal" onClick={(e) => this.ExceededOkClick()}>OK</button>
                            </div>
                        </div>
                    </div>
                </div>
                {/*Approval comments modal starts here*/}
                <div class="modal fade approval-popup pl-0" id="ApprovalComments" tabindex="-1" role="dialog" aria-hidden="true" data-keyboard="false" data-backdrop="static">
                    <div class="modal-dialog modal-dialog-centered" role="document">
                        <div class="modal-content border-0">
                            <div class="modal-header sp-delv-header align-items-center">
                                <h5 class="modal-title" >Approval comments</h5>
                                <button type="button" className="btn close-btn" data-dismiss="modal" onClick={() => this.cancelclick()} >
                                    X
                                </button>
                            </div>

                            <div class="modal-body px-4">
                                <div class="row">

                                    <div class="col-md-12 mb-3">
                                        <label class="form-label catalog-label" for="comments">Comments</label>
                                        <textarea class="form-control" id="ApprvComment" placeholder="Enter comments" maxLength="254" value={this.state.Comments} onChange={(e) => this.HandleComments(e)} rows="3"></textarea>
                                    </div>

                                </div>
                            </div>

                            <div class="modal-footer border-0 pt-1 mb-2 px-4">
                                <button id="ApprvCommentCancel" class="btn btn-secondary custom-btn-secondary secondary-btn mr-2 px-4 py-2" data-dismiss="modal" onClick={() => this.cancelclick()}>Cancel</button>
                                <button id="ApprvCommentSave" class="btn btn-custom-primary font-15 font-medium px-4 py-2" onClick={() => this.aprvalContinue(false)}>Save</button>
                            </div>

                        </div>
                    </div>
                </div>
                {/*Approval comments modal ends here*/}
            </div>
        );

    }

}

export default withTranslation()(WaitingRequestorApprovalComponent);